<template>
  <div class="main">
    <div class="swipe">
      <img src="../../assets/bg.png" alt />
    </div>
    <div class="program">
      <div class="showSomeProgram">
        <div class="pheader">
          <i class="el-icon-arrow-left"></i>
          <span @click="ret">返回列表是是是</span>
        </div>
        <div class="pLine"></div>
        <div class="video" v-if="newsData.journalism">
          <!-- <canvas id="mycanvas" width="800" height="600" ref="canvas"></canvas> -->
          <video
            id="upvideo"
            ref="myVideo"
            style="width:5.6rem;height:3.15rem"
            controls
          ></video>
        </div>
        <div class="pabs">
          <h2>{{ newsData.name }}</h2>
          <h4>
            <span>{{ newsData.putime }}</span>
            <span>浏览量 : {{ newsData.countpublic }}</span>
          </h4>
          <div class="pabsContent" v-html="newsData.content"></div>
        </div>
        <div class="rebtn">
          <el-button @click="ret" type="primary">返回列表</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getNewsDetail } from "@/api/news.js"
import Bus from "@/utils/bus.js"
import { BASE_URL } from "@/utils/base.js"
export default {
  name: "Home",
  data() {
    return {
      url: "",
      newsData: {},
    }
  },
  mounted() {
    window.scrollTo({
      top: 0,
    })
    this.$nextTick(function() {
      Bus.$emit("getCurrent", "hdzs")
    })
    this.getData()
    // console.log(this.$route.params);
    // this.$nextTick(()=>{
    //  this.$refs.myVideo.src = "../../assets/demo.mp4";
    // })
  },
  methods: {
    // 获取数据
    async getData() {
      let news = new FormData()
      news.append("id", this.$route.params.id)
      let data = await getNewsDetail(news)
      console.log(data)
      this.newsData = data
      if (this.newsData.journalism) {
        this.newsData.journalism = BASE_URL + this.newsData.journalism
        this.$nextTick(() => {
          this.findvideocover()
        })
      }
    },
    // 返回上一页
    ret() {
      this.$router.go(-1)
    },
    findvideocover() {
      const video = document.getElementById("upvideo") // 获取视频对象
      //   const video = document.createElement("video") // 也可以自己创建video
      // video.src='http://mall.private.netcente.com/cf0eec5e-6b17-4966-be4d-8b1b516970d9?e=1588057847&token=ew7Ezvrwgr2v8GBps2vP0TJFLK2G90ewUGzeFKam:IyXlq6S97GLEq7EiR27V6kU4dgg=' // url地址 url跟 视频流是一样的
      let source = document.createElement("source")
      // this.$refs.myVideo.src = this.programData.intvideo;
      source.src = this.newsData.journalism
      //   source.src = "http://123.56.170.62:1120/static/video/61ce8258-3460-45fc-a98d-358311cbd568.mp4";
      source.type = "video/mp4"
      video.appendChild(source)
      // var canvas = document.getElementById("mycanvas"); // 获取 canvas 对象
      // const ctx = canvas.getContext("2d"); // 绘制2d
      video.crossOrigin = "anonymous" // 解决跨域问题，也就是提示污染资源无法转换视频
      video.currentTime = 1 // 第一帧
      // video.oncanplay = () => {
      //   canvas.width = video.clientWidth; // 获取视频宽度
      //   canvas.height = video.clientHeight; //获取视频高度
      //   // 利用canvas对象方法绘图
      //   ctx.drawImage(video, 0, 0, video.clientWidth, video.clientHeight);
      //   // 转换成base64形式
      //   // console.log(canvas.toDataURL ("image/png"))
      //   this.url = canvas.toDataURL("image/png");
      //   ctx.drawImage(video, 0, 0, 0, 0);
      //   this.videoImg = canvas.toDataURL ("image/png") // 截取后的视频封面
      // };
    },
  },
  components: {},
}
</script>
<style lang="less" scoped>
.main {
  width: 100%;
  .swipe {
    width: 100%;
    img {
      width: 100%;
      height: 400px;
    }
  }
  .program {
    padding-bottom: 42px;
    width: 100%;
    background-color: #fff;
    .showSomeProgram {
      width: 854px;
      margin: 40px auto;
      text-align: center;
      .pheader {
        text-align: left;
        margin: 40px 15px 20px;
        font-size: 16px;
        i {
          color: #ff4040;
          margin-right: 10px;
        }
        span {
          color: #000;
          cursor: pointer;
        }
      }
      .pLine {
        width: 100%;
        height: 2px;
        margin: 0;
        background-color: #f5f5f5;
      }
      .video {
        margin-top: 30px;
      }
      .pabs {
        width: 620px;
        margin: 60px auto 0;
        display: flex;
        flex-direction: column;
        font-size: 14px;
        color: #000;
        h2 {
          font-size: 24px;
          color: #000;
          text-align: center;
          margin-bottom: 30px;
        }
        .pabsContent {
          p {
            line-height: 1.5;
            text-align: center;
          }
        }
        h4 {
          display: flex;
          margin-bottom: 20px;
          justify-content: flex-end;
          span {
            margin-right: 10px;
          }
        }
      }
      .rebtn {
        margin-top: 60px;
      }
    }
  }
}
</style>
